<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(repair, index) in splitRepairsIntoChunks[currentPage - 1]"
        :key="index"
        cols="12"
      >
        <card
          :id="repair.id"
          :site="repair.site"
          :completed="repair.completed"
          :problemType="repair.problemType"
          :description="repair.description"
          :created_at="repair.created_at"
          :repairItems="repair.repairItems"
        />
      </v-col>
    </v-row>
    <div class="text-center">
      <v-pagination
        v-model="currentPage"
        :length="totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Card from "@/components/Card";
import { repairsCollection } from "@/db";

export default {
  name: "Completed",
  data: () => ({
    currentPage: 1,
    finishedRepairs: [],
    perChunk: 10
  }),
  components: { card: Card },
  created() {
    repairsCollection
      .where("completed", "==", true)
      .orderBy("created_at")
      .limit(50)
      .get()
      .then(querySnapshot => {
        querySnapshot.docs.forEach(element => {
          const repairData = {
            id: element.id,
            site: element.data().site,
            completed: element.data().completed,
            problemType: element.data().problemType,
            repairItems: element.data().repair_items.length,
            description: element.data().description,
            created_at: element
              .data()
              .created_at.toDate()
              .toISOString()
              .slice(0, 10)
          };
          this.finishedRepairs.push(repairData);
        });
      });
  },
  computed: {
    totalPages() {
      return Math.ceil(this.finishedRepairs.length / this.perChunk);
    },
    splitRepairsIntoChunks() {
      return this.finishedRepairs.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / this.perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
    }
  }
};
</script>
